import * as faceapi from "face-api.js";

const MODEL_URL = "https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js/weights";
let modelsPromise = null;

export function loadFaceModels() {
  if (!modelsPromise) {
    modelsPromise = Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
      faceapi.nets.faceLandmark68TinyNet.loadFromUri(MODEL_URL),
      faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
    ]);
  }
  return modelsPromise;
}

export async function detectFaceDescriptor(videoOrImage) {
  await loadFaceModels();
  const result = await faceapi
    .detectSingleFace(videoOrImage, new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.5 }))
    .withFaceLandmarks(true)
    .withFaceDescriptor();
  if (!result) return null;
  return {
    descriptor: Array.from(result.descriptor),
    box: result.detection.box,
  };
}

function frameBrightness(src, W, H) {
  const c = document.createElement("canvas");
  c.width = 64; c.height = Math.max(1, Math.round((64 * H) / W));
  const ctx = c.getContext("2d");
  ctx.drawImage(src, 0, 0, c.width, c.height);
  const d = ctx.getImageData(0, 0, c.width, c.height).data;
  let sum = 0, hot = 0;
  for (let i = 0; i < d.length; i += 4) {
    const y = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
    sum += y; if (y >= 250) hot += 1;
  }
  const n = d.length / 4;
  return { mean: sum / n, hot: hot / n };
}

// Conferência de qualidade para CADASTRO facial (todas as telas): 1 rosto, centralizado, tamanho, frontal, luz.
export async function detectEnrollFace(video) {
  await loadFaceModels();
  const W = video.videoWidth || video.naturalWidth || video.width;
  const H = video.videoHeight || video.naturalHeight || video.height;
  const all = await faceapi
    .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions({ inputSize: 416, scoreThreshold: 0.5 }))
    .withFaceLandmarks(true)
    .withFaceDescriptors();
  if (!all.length) return { problem: "Nenhum rosto detectado — olhe para a câmera com boa iluminação" };
  if (all.length > 1) return { problem: "Mais de um rosto na imagem — apenas o aluno deve aparecer na foto" };
  const r = all[0], b = r.detection.box;
  const cx = (b.x + b.width / 2) / W, cy = (b.y + b.height / 2) / H;
  const inside = (p) => p.x >= 0 && p.y >= 0 && p.x <= W && p.y <= H;
  const lm = r.landmarks;
  const parts = [...lm.getLeftEye(), ...lm.getRightEye(), ...lm.getNose(), ...lm.getMouth()];
  const le = lm.getLeftEye()[0], re = lm.getRightEye()[3], nose = lm.getNose()[3];
  const eyeDist = Math.max(1, Math.abs(re.x - le.x));
  const lum = frameBrightness(video, W, H);
  let problem = "";
  if (b.width / W < 0.18) problem = "Rosto muito longe — aproxime-se da câmera";
  else if (b.width / W > 0.8 || b.height / H > 0.9) problem = "Rosto muito perto — afaste-se um pouco da câmera";
  else if (Math.abs(cx - 0.5) > 0.22 || cy < 0.2 || cy > 0.75) problem = "Centralize o rosto no meio da tela";
  else if (!parts.every(inside)) problem = "Olhos, nariz e boca precisam aparecer inteiros na foto";
  else if (Math.abs(nose.x - (le.x + re.x) / 2) / eyeDist > 0.35) problem = "Olhe de frente para a câmera";
  else if (r.detection.score < 0.6) problem = "Rosto pouco nítido — fique parado e melhore a iluminação";
  else if (lum.mean < 30) problem = "Foto muito escura — procure um local mais iluminado";
  else if (lum.mean > 225 || lum.hot > 0.3) problem = "Luz forte ou reflexo — evite luz direta atrás ou no rosto";
  if (problem) return { problem };
  return { descriptor: Array.from(r.descriptor), box: b };
}


export function drawBox(canvas, box, label = "", color = "#E11D48") {
  const ctx = canvas.getContext("2d");
  ctx.strokeStyle = color;
  ctx.lineWidth = 3;
  ctx.strokeRect(box.x, box.y, box.width, box.height);
  if (label) {
    ctx.fillStyle = color;
    ctx.fillRect(box.x, box.y - 22, ctx.measureText(label).width + 12, 22);
    ctx.fillStyle = "#fff";
    ctx.font = "bold 14px Outfit";
    ctx.fillText(label, box.x + 6, box.y - 6);
  }
}

export { faceapi };
